














import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class four04 extends Vue {
    constructor(){
        super();
    }
}

